// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"62025cf2","165":"60a3be94","364":"452bbaa0","383":"2a2b30f6","448":"2497e68a","483":"ebe815c1","486":"3554306b","497":"e2ad96cc","592":"4e058992","724":"4f8abb3c","765":"25c4676e","815":"732eafd1","821":"778a3af8","847":"47739daa","985":"565672f6"}[chunkId] + ".chunk.js";
};